import { render, staticRenderFns } from "./LegalesListado.vue?vue&type=template&id=5320ac7f&"
import script from "./LegalesListado.vue?vue&type=script&lang=js&"
export * from "./LegalesListado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports